import store from '@/store'

const { body } = document
const WIDTH = 992 // 移动端临界值，小于视为移动端

export default {
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    if (isMobile) {
      store.dispatch('setMobileStatus',isMobile)
    }
    this.active = 1;
    this.$router.push({ path: "/" });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  methods: {
    $_isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
       /* 页面可见时，防止隐藏时触发resize */
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        store.dispatch('setMobileStatus',isMobile)
      }
    }
  }
}
